module.exports = __webpack_public_path__ + "images/category_lp/fishing_gear/point3_fbe282efc1facb430d6cbab8c94ee93e.png";